import type { SemInventoryModuleSectionContent } from '~/contracts/sem';
import Chevron from '~/icons/Chevron';
import { Tile, TileText, IconWrapper } from './ContentTile.styles';

const ContentTile = ({
  viewAllLink,
  viewMoreTileText
}: Partial<SemInventoryModuleSectionContent>) => {
  return viewAllLink ? (
    <a
      href={viewAllLink}
      key={viewAllLink}
      data-analytics-id="Inventory - Content Tile"
      className="inline-block h-[275px] !w-[274px] no-underline"
      data-analytics-attributes={JSON.stringify({
        title: viewMoreTileText,
        linkUrl: viewAllLink
      })}
    >
      <Tile>
        <TileText>{viewMoreTileText}</TileText>
        <IconWrapper>
          <Chevron className="h-12" />
        </IconWrapper>
      </Tile>
    </a>
  ) : null;
};

export default ContentTile;
